import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	whoCanAccessChannels: {
		id: 'servicedesk-customer-permissions.form.content.questions.who-can-access-channels',
		defaultMessage: 'Channel access',
		description: 'Label text for the customer access dropdown describing channels access options',
	},
	channelsAccessDescription: {
		id: 'servicedesk-customer-permissions.form.content.questions.channels-access-description',
		defaultMessage:
			'Control who can submit requests to this project by email, widget, or <link>the portal</link>',
		description: 'Text of description for channels access',
	},
	restrictedAccessToAddedByAdminOrAgentOnly: {
		id: 'servicedesk-customer-permissions.form.content.questions.restricted-access-to-added-by-admin-or-agent-only',
		defaultMessage: 'Customers added to this service project only by agents and admins',
		description:
			'Radio option to restrict who can access the portal only to users who are added by agents or admins.',
	},
	channelsAccessSiteAdminHint: {
		id: 'servicedesk-customer-permissions.form.content.questions.channels-access-site-admin-hint',
		defaultMessage:
			'Channel access is also affected by the site’s customer access settings.<br></br>Jira admins can <link>update the customer access settings</link>',
		description:
			'Hint to tell the site admin that they can change the customer access settings via the link.',
	},
	organisationsSharingTip: {
		id: 'servicedesk-customer-permissions.form.content.questions.organisations-sharing-tip',
		defaultMessage:
			'To set who customers can automatically share new requests with, site admins can {globalSettings}',
		description: "Description and link to 'change the Global settings'",
	},
	globalSettingsLink: {
		id: 'servicedesk-customer-permissions.form.content.questions.global-settings-link',
		defaultMessage: 'change the Global settings {shortcutIcon}.',
		description: "link to 'change the Global settings'",
	},
	customerAccessSettingsLink: {
		id: 'servicedesk-customer-permissions.form.content.questions.customer-access-settings-link',
		defaultMessage: 'change the customer access settings {shortcutIcon}.',
		description: 'link to change protal-only customer access settings',
	},
	shortcutIconLabel: {
		id: 'servicedesk-customer-permissions.form.content.questions.shortcut-icon-label',
		defaultMessage: 'link will open in a new tab',
		description: 'label for the icon showing that the link will open in a new tab',
	},
	shareRequestEmailonly: {
		id: 'servicedesk-customer-permissions.form.content.questions.share-request-emailonly',
		defaultMessage:
			'Customers can search for other customers within their organizations, or manually enter the email address of other customers within their project',
		description: 'Second radio option text for customer sharing settings',
	},
	shareRequestSearchAutoComplete: {
		id: 'servicedesk-customer-permissions.form.content.questions.share-request-search-auto-complete',
		defaultMessage:
			'Customers can search for other customers within their project or organizations',
		description: 'Third radio option text for customer sharing settings',
	},
	shareRequestAgentonly: {
		id: 'servicedesk-customer-permissions.form.content.questions.share-request-agentonly',
		defaultMessage: 'Customers can search for other customers within their organizations',
		description: 'First radio option text for customer sharing settings',
	},
	allowAccessBaseOnGlobalCustomerAccessSettingsOption: {
		id: 'servicedesk-customer-permissions.form.content.questions.allow-access-base-on-global-customer-access-settings-option',
		defaultMessage: 'Anyone allowed on the customer access settings',
		description:
			'Radio option to allow new users to access the portal themself base on the customer access settings.',
	},
	newCustomerWarning: {
		id: 'servicedesk-customer-permissions.form.content.questions.new-customer-warning',
		defaultMessage:
			'The selected settings will also allow existing customers to add new customers to the project by:',
		description:
			'Text for warning message displayed if customer permissions settings allow adding new customers',
	},
	whoCanCustomersShareRequestDescription: {
		id: 'servicedesk-customer-permissions.form.content.questions.who-can-customers-share-request-description',
		defaultMessage:
			'Control how existing customers can find other customers and share requests with them:',
		description: 'Label text for the radio group setting who customers may share requests with',
	},
	whoCanCustomersShareRequest: {
		id: 'servicedesk-customer-permissions.form.content.questions.who-can-customers-share-request',
		defaultMessage: 'Customer sharing',
		description: 'Label text for the radio group setting who customers may share requests with',
	},
	newCustomersByEmailInfo: {
		id: 'servicedesk-customer-permissions.form.content.questions.new-customers-by-email-info',
		defaultMessage:
			'Agents and project admins can add new customers to a project at any time by including their email address in the "To" or "Cc" field when replying to a request’s email notification. {usersAndRolesLearnMoreLink}',
		description:
			'Text for information panel explaining that agents and project admins can always add customers via email.',
	},
	learnMoreLinkJsm: {
		id: 'servicedesk-customer-permissions.form.content.questions.learn-more-link-jsm',
		defaultMessage: 'Learn more about users and roles in Jira Service Management.',
		description: 'Link title for documentation link explaining users and roles',
	},
	newCustomerViaPortal: {
		id: 'servicedesk-customer-permissions.form.content.questions.new-customer-via-portal',
		defaultMessage: 'entering their email address in the portal, or;',
		description:
			'Text of warning item showing customer can add new customers by adding an email address in the help centre',
	},
	newCustomerViaEmail: {
		id: 'servicedesk-customer-permissions.form.content.questions.new-customer-via-email',
		defaultMessage:
			'including their email address in the "To" or "Cc" field when replying to a request’s email notification.',
		description: 'Text of warning item showing customers can add new customers via email',
	},
});
